// Hide more than 5 color variants on product page

document.addEventListener("DOMContentLoaded", function () {
  const showMoreLink = document.getElementById("showMoreVariants");
  if (showMoreLink) {
    showMoreLink.addEventListener("click", function () {
      document.querySelectorAll(".hidden-variant").forEach(function (variant) {
        variant.style.display = "block"; // or variant.classList.remove('hidden-variant');
      });
      showMoreLink.style.display = "none"; // Hide the link after expanding
    });
  }
});